import { Event } from '../../components/Event';

const Events = () => <Event />;

export default Events;
